module.exports = __webpack_public_path__ + "static/media/Professional-Quality.f200c613.png";